import React from 'react';
import { Panel } from '@dealroadshow/uikit/core/components/PanelGroup';
import IconExpand from '@dealroadshow/uikit/core/components/Icon/IconExpand';
import IconCollapse from '@dealroadshow/uikit/core/components/Icon/IconCollapse';

import styles from '../styles.scss';

interface IProps {
  hash: string,
  question: string,
  answer: React.JSX.Element,
}

const FaqItem = ({ hash, question, answer }: IProps) => (
  <Panel
    dataTest={ hash }
    id={ hash }
    header={ question }
    arrow={ <IconExpand /> }
    arrowActive={ <IconCollapse /> }
    className={ styles.faqPanelItem }
    activeClass={ styles.faqActivePanelItem }
    headerClass={ styles.faqPanelItemHeader }
    arrowWrapperClass={ styles.faqPanelItemArrow }
    contentClass={ styles.faqPanelItemContent }
  >
    { answer }
  </Panel>
);

export default FaqItem;
